/** 服务价格 **/
<template>
  <div content="servicePrice">
    <div class="content"
         v-html="infoData"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'servicePrice',
    computed: {
      ...mapGetters({
        companyInfo: 'companyInfo'
      })
    },
    data () {
      return {
        infoData: ''
      }
    },
    methods: {
      ArticlebyaliasFn () {
        let that = this
        let params = {
          'alias': 'CutomerPricingRules',
          'app_key': window.configure.appKey,
          'companyId': that.companyInfo.id,
          fn (data) {
            if (data && data.code === 1) {
              that.infoData = data.article.contents
            }
          }
        }
        that.$store.dispatch('Articlebyalias', params)
      }
    },
    watch: {
      'companyInfo.id' (val) {
        if (val) {
          this.ArticlebyaliasFn()
        }
      }
    },
    mounted: function () {
      this.ArticlebyaliasFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .servicePrice {
    img {
      width: 100% !important;
    }
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// servicePrice.vue?310ce22f